// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
blockquote.translated-query {
    background-color: #dddddd;
    padding: 8px;
    border: 1px solid #888888;
    border-radius: 8px;    
}`, "",{"version":3,"sources":["webpack://./src/components/search/XSifterQueryRevision.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB","sourcesContent":["\r\nblockquote.translated-query {\r\n    background-color: #dddddd;\r\n    padding: 8px;\r\n    border: 1px solid #888888;\r\n    border-radius: 8px;    \r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
